import React , { useState , useEffect , useRef } from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import {
     Class_ETC_Warning_actionYesandNo
    ,Class_ETC_MsgError
  } from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
import ConfigETC from "../Class/ConfigETC.json";


/* Create By Poom : 08-06-2023 
   Edit By POOM : 03-05-2024
    - เพิ่มการแสดง 
    - จำนวนวัน  (วางหลัง PER DIEM )
    - ระยะทาง(กม.) วางไว้หลัง ช่อง TRAVEL
    (เพิ่มช่องบันทึก แล้ว TS_exp_extra_day,TS_exp_travel_distance)
    
  Edit BY POOM : 09-05-2024 
    - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
	


*/
function Timesheet_Cell_DayProject(props) {
    const { tsid 
            , day 
            , dt_day
            , dt_dayFull
            , wt_time
            , tss
            , tte
            , ot
            , act_edit
            , ActProject
            , pro_id
            , project_name
            , task_id
            , timeoff_id
            , act_task_timeoff
            , onclick_ModalEditTimeSheet
            , customer_name
            , taskname
            , tasksubname
            , timeoff_name
            , pos_name
            , ee
            , et
            , eo
            , eed
            , etd
            , desc
            , tsssn
            , tsrd
            , ud
            , usn
            , tsd
            , ot_time
            , act_cancel
            , act_del
            , rowindex
            , holiday
            , SaveTimeSheet
            , DelTimesheet
            , resetvalue
            , isSVOT
            } = props;
    const djstext = "2022-04-17T"
    const [uswt_time, setuswt_time] = useState((wt_time === "" ? null : dayjs(djstext + wt_time)));
    //const [value, setValue] = React.useState<Dayjs | null>(dayjs('2022-04-17T' + (wt_time === "" ? "00:00" : wt_time)));
    const Refid_txt = useRef(null); 
    const [isonfocus , setIsonfocus] = useState(false);
    
    useEffect(() => {
        if (resetvalue) {
            setuswt_time((wt_time === "" ? null : dayjs(djstext + wt_time)))
        }
        // eslint-disable-next-line
    }, [resetvalue]);
    
    const onchang_time = (newTime) => {
        setuswt_time(newTime);
    };

    const onblue_time = (e) => {
        
        let data = e.target.value;
        setIsonfocus(false)
        if (data === "hh:mm" && tsid === 0)
        {
            //ปล่อยผ่านไป
        }
        else
        {
            data = data.replace("h", "0");
            data = data.replace("h", "0");
            data = data.replace("m", "0");
            data = data.replace("m", "0");
            
            if (data === wt_time)
            {
                //Not active
            }
            else if (data === "00:00" && tsid === 0)
            {
                setuswt_time(null)
                if (act_task_timeoff === "T")
                {
                    Class_ETC_MsgError(MsgDescription.ERR026, on_FocasByMsg);
                }
                else
                {
                    Class_ETC_MsgError(MsgDescription.ERR023, on_FocasByMsg);
                }
            }
            else if (data === "00:00" && ot === 0 && tsid !== 0)
            {
                //ถ้า 00:00 เมื่อไหร่  และ ot เดิมเป็น  0 แสดงว่าเราจะทำการ del ข้อมูลชุดนี้
                setuswt_time(null)
                Class_ETC_Warning_actionYesandNo(MsgDescription.CFM002 , yesfunctiondel , nofunctiondel)
            }
            else
            {
                const _isresult = { result: 0 };
                SaveTimeSheet(tsid
                            ,dt_day
                            ,pro_id
                            ,task_id
                            ,timeoff_id
                            ,data
                            ,""
                            ,0
                            ,0
                            ,0
                            ,0
                            ,0
                            ,""
                            ,""
                            ,"textbox"
                            ,day
                            ,rowindex
                            ,_isresult
                            ,function() {
                                if (_isresult.result === 0)
                                {
                                    if (tsid !== 0)
                                    {
                                        setuswt_time((wt_time === "" ? null : dayjs(djstext + wt_time)))
                                    }
                                    else
                                    {
                                        setuswt_time(null)
                                    }
                                    on_FocasByMsg()
                                }
                                else
                                {
                                    setuswt_time(dayjs(djstext + data))
                                }
                            });
            }

        }

        
    };

    function yesfunctiondel(){
        const _isresult = { result: 0 };
        DelTimesheet(tsid
                    ,day
                    ,rowindex
                    ,""
                    ,_isresult
                    ,function() {
                      if (_isresult.result === 1)
                      {
                        setuswt_time(null)
                      }
                      else
                      {
                        setuswt_time((wt_time === "" ? null : dayjs(djstext + wt_time)))
                      }
                    })
        
    }

    function nofunctiondel(){
        setuswt_time((wt_time === "" ? null : dayjs(djstext + wt_time)))
    }

    function on_FocasByMsg()
    {
        setIsonfocus(true);
        setTimeout(() => {
            setIsonfocus(false);
        }, 10000);
    }


  return (
    <>
        

        <div className="divOuter">
       

            <div className="divInner">
                <input type="hidden" id="dayp_hd_id" ></input>
                <input type="hidden" id="dayp_tsid" value={tsid} ></input>
                <input type="hidden" id="dayp_day" value={day} ></input>
                <input type="hidden" id="dayp_dt_day" value={dt_day} ></input>
                {(act_edit === "y" && ((holiday === 'y' && act_task_timeoff === "T") || holiday !== 'y') && 
                    <>
                     <span className="float-left status-icon">
                            {tte > 0 ? <i className="far fa-money-bill-alt" title="Expense"></i>
                                : ""}
                           {" "}
                            {ot > 0 && isSVOT === true ? 
                            <i className="far fa-lightbulb" title="OT"></i>
                            : ""
                            }

                            
                    </span>
                            {uswt_time > 0  ? 
                            <span className="float-left status-icon mt-4 ml-1">
                                {(act_task_timeoff === "T" &&
                                        <>
                                            <i className="far fa-clock" title="WT"></i>
                                        </>
                                    ) ||
                                    (
                                        <>
                                         <i className="far fa-pause-circle" title="Time off"></i>
                                        </>
                                    )}
                            </span>
                            : ""
                            }
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <TimeField ampm={false}  
                                // ปรับใหม่  นับ reject = reject จริงๆ
                                // error={(tss === ConfigETC.TS_Reject_Value 
                                //     || (tss === ConfigETC.TS_InProgress_Value  && tsrd !== "")
                                //          ? true : false)}
                                error={(tss === ConfigETC.TS_Reject_Value)}
                                size="small"
                                onBlur={onblue_time}
                                value={uswt_time}
                                onChange={onchang_time}
                                ref={Refid_txt}
                                focused={isonfocus}
                                label={(tss === ConfigETC.TS_Reject_Value ? ConfigETC.TS_Reject_Text : "")}
                                className={"text-center"}
                                sx={{
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "#d9dfe5",
                                      borderStyle:"solid",
                                      borderWidth:"1px"
                                    },
                                    
                                  "& .MuiOutlinedInput-root": {
                                    "&:hover:not(.Mui-focused)": {
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#d9dfe5",
                                        borderStyle:"solid",
                                        borderWidth:"1px"
                                      },
                                    },
                                  }
                                }}

                                // sx={{
                                //     "& .MuiOutlinedInput-root": {
                                //       color: "#000",
                                //       fontFamily: "Arial",
                                //       fontWeight: "bold",
                                //     "& .MuiOutlinedInput-notchedOutline": {
                                //         borderColor: "#d9dfe5",
                                //         borderStyle:"solid",
                                //         borderWidth:"1px",
                                //         textAlign:"center"
                                        
                                //       },
                                //     "& .MuiOutlinedInput-root": {
                                //       "&:hover:not(.Mui-focused)": {
                                //         "& .MuiOutlinedInput-notchedOutline": {
                                //           borderColor: "#d9dfe5",
                                //           borderStyle:"solid",
                                //           borderWidth:"1px"
                                //         },
                                //       },
                                //     }

                                //   }}

                                //onBlur={(e) => handleBlur(e)}
                                //onChange={()=>undefined}

                                // value={value}
                                // onChange={(newValue) => setValue(newValue)}
                            />
                        </LocalizationProvider>
                        
                    </>
                )
                ||
                (
                <>
                    {wt_time === "" || wt_time === "00:00" ? "" :  
                        <>
                            <div className="mt-1">
                                <span className="float-left span-icon">

                                    {(act_task_timeoff === "T" &&
                                        <>
                                            <i className="far fa-clock" title="WT"></i>
                                        </>
                                    ) ||
                                    (
                                        <>
                                         <i className="far fa-pause-circle" title="Time off"></i>
                                        </>
                                    )}

                                </span>
                                <span className="span-lable">
                                    {wt_time.substring(0, 2) === "00" ? "" : 
                                    <>
                                        {wt_time.substring(0, 1) === "0" ? 
                                            <>
                                                {wt_time.substring(1,2)}
                                                 <span >h</span> 
                                            </> 
                                            : 
                                            <>
                                                {wt_time.substring(0, 2)}
                                                 <span >h</span> 
                                            </>
                                        }
                                    </>
                                    }
                                    {wt_time.substring(3) === "00" ? "" : 
                                    <>
                                         {" "}
                                        
                                        {/* {wt_time.substring(3)} */}
                                        {parseInt(wt_time.substring(3))} 
                                         <span >m</span> 
                                    </>
                                    }
                                </span>
                            </div>
                        </>
                    }
                    {isSVOT &&
                    <>
                        {ot_time === "" || ot_time === "00:00" ? "" :  
                        <>
                            <div>
                                <span className="float-left span-icon">
                                    <i className="far fa-lightbulb" title="OT"></i>
                                </span>
                                <span className="span-lable">
                                    {ot_time.substring(0, 2) === "00" ? "" : 
                                        <>
                                            {ot_time.substring(0, 1) === "0" ? 
                                                <>
                                                    {ot_time.substring(1,2)}
                                                     <span >h</span>
                                                </> 
                                                : 
                                                <>
                                                    {ot_time.substring(0, 2)}
                                                    <span >h</span> 
                                                </>
                                            }
                                        </>
                                    }
                                    
                                    {ot_time.substring(3) === "00" ? "" : 
                                        <>
                                             {" "}
                                            {/* {ot_time.substring(3)} */}
                                            {parseInt(ot_time.substring(3))} 
                                            <span >m</span> 
                                        </>
                                    }
                                </span>
                            </div>
                        </>
                        }
                    </>
                    }
                    <span className="status-icon">
                        {tte > 0 ? <i className="far fa-money-bill-alt" title="Expense"></i> : ""}
                    </span>
                </>
                )}
            </div>
            {(((holiday === 'y' && act_task_timeoff === "T") || 
               (holiday === 'y' && act_task_timeoff === "TO" && tsid !== 0) ||
                holiday !== 'y'
                ) && 
                <div className="divOverlap">
                    <a href="#!" title="Edit timesheet" data-target="#modal-TimeSheet" data-toggle="modal"
                    onClick={() => onclick_ModalEditTimeSheet(ActProject 
                                                            , pro_id
                                                            , task_id
                                                            , timeoff_id
                                                            , act_task_timeoff
                                                            , project_name
                                                            , day
                                                            , dt_dayFull
                                                            , customer_name
                                                            , taskname
                                                            , tasksubname
                                                            , timeoff_name
                                                            , pos_name
                                                            , ee
                                                            , et
                                                            , eo
                                                            , eed
                                                            , etd
                                                            , desc
                                                            , tsssn
                                                            , tsrd
                                                            , ud
                                                            , tss
                                                            , usn
                                                            , tsd
                                                            , ot_time
                                                            , wt_time
                                                            , act_cancel
                                                            , act_del
                                                            , (holiday === 'y' && act_task_timeoff === "TO" && tsid !== 0 ? "" : act_edit)
                                                            , rowindex
                                                            , tsid
                                                            , dt_day
                                                            )} >
                        <i className="fas fa-pencil-alt fa-lg" />
                    </a>
                </div>
            )}
        </div>
    </>
  )
}

export default Timesheet_Cell_DayProject